export { MinervaSPA } from './MinervaSPA.component';
